import React from 'react';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';

export const LightspeedKSeriesSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => {
    if (locationId === undefined) {
        return null;
    }
    return (
        <SettingDisplay label="Business Location ID">
            <TextFormField name="lightspeedKSeriesLocationId" />
        </SettingDisplay>
    );
};
